import { ReactNode } from 'react'
import {
    getShipmentDisplayCalculated,
    isShipmentCalculatedOnActual,
} from '../../helpers/entities/shipment/get-shipment-display-calculated'
import Calculated from '../../types/api/components/calculation-position/calculated'
import Shipment from '../../types/api/shipment'
import ShipmentCalculatedValue from './shipment-calculated-value'

export function renderShipmentCalculatedValue(
    shipment: Pick<Shipment, 'calculated' | 'calculatedOnActual'> | undefined | null,
    render: (calculated: Calculated | undefined) => ReactNode
) {
    return (
        <ShipmentCalculatedValue isActual={isShipmentCalculatedOnActual(shipment)}>
            {render(getShipmentDisplayCalculated(shipment))}
        </ShipmentCalculatedValue>
    )
}
